import React from 'react';
import Handler from '../../commonTypes/handler.types';
import DefaultProps from '../../commonTypes/defaultprops.types';

// Types of Button Color Types
export enum ButtonStyles {
  DEFAULT = 'default',
  BLACK = 'black',
  GREY = 'grey',
  LINK_BLUE = 'link-blue',
  MLB_TV_ORANGE = 'mlb-tv-orange',
  SELECTED_TAB = 'selected-tab',
  TEAM = 'team',
  TICKET_LINK_GREEN = 'ticket-link-green',
}

// Types of Button Styles
export enum ButtonShapes {
  HOLLOW = 'hollow',
  HOLLOW_BORDERLESS = 'hollow-borderless',
  PILL = 'pill',
  PILL_SOLID = 'pill-solid',
  SOLID = 'solid',
  TAB = 'tab',
}

// Button Sizes
export enum ButtonSizes {
  XSMALL = 'xs',
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  XLARGE = 'xl',
}

// Button Types
export enum ButtonTypes {
  BUTTON = 'button',
  RESET = 'reset',
  SUBMIT = 'submit',
}

// All the props for the Button Component
export interface ButtonProps extends DefaultProps {
  active?: boolean;
  additionalProps?: object;
  ariaPressed?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  handlers?: Handler;
  hasHover?: boolean;
  hoverSpeed?: number;
  iconProps?: object;
  iconColor?: string;
  iconHoverColor?: string;
  iconLeft?: boolean;
  iconName?: string;
  iconSize?: number;
  label?: string;
  role?: string;
  shape?: ButtonShapes;
  size?: ButtonSizes;
  styleName?: ButtonStyles;
  type?: ButtonTypes;
  value?: string | object | unknown[] | number | boolean;
}

export interface IndividualButtonSizes {
  fontSize: number;
  height: number;
  horizontalPadding: number;
  iconSize: number;
  iconPaddingTop: number;
}
interface ButtonSizeMap {
  xs: IndividualButtonSizes;
  sm: IndividualButtonSizes;
  md: IndividualButtonSizes;
  lg: IndividualButtonSizes;
  xl: IndividualButtonSizes;
}

// A map of the various sizes detailing various styling tweaks per size
export const buttonSizeMap: ButtonSizeMap = {
  xs: {
    fontSize: 12,
    height: 24,
    horizontalPadding: 10,
    iconSize: 13,
    iconPaddingTop: 1,
  },
  sm: {
    fontSize: 13,
    height: 32,
    horizontalPadding: 10,
    iconSize: 14,
    iconPaddingTop: 1,
  },
  md: {
    fontSize: 15,
    height: 36,
    horizontalPadding: 10,
    iconSize: 16,
    iconPaddingTop: 1,
  },
  lg: {
    fontSize: 18,
    height: 42,
    horizontalPadding: 15,
    iconSize: 18,
    iconPaddingTop: 1,
  },
  xl: {
    fontSize: 20,
    height: 48,
    horizontalPadding: 20,
    iconSize: 18,
    iconPaddingTop: 2,
  },
};

export type ButtonRef = HTMLButtonElement;
